// @ts-check
import Axios from 'axios';

import { PreviewKey } from '@/store/modules/users/models';
import HTTP from '@/utils/http';

/**
 * @typedef {import('@/store/modules/users/models/PreviewKey').TPreviewKey} TPreviewKey
 */

/**
 * Fetch current user preview key
 *
 * @param {AbortSignal} signal
 * @returns {Promise<TPreviewKey>}
 */
export async function fetchUserCurrentPreviewKey(signal) {
  // Create a new CancelToken source for this request
  const source = Axios.CancelToken.source();

  const response = await HTTP({
    url: 'users/current/preview-key',
    cancelToken: source.token,
  });

  // Cancel the request if TanStack Query signals to abort
  signal?.addEventListener('abort', () => {
    source.cancel('Query was cancelled by TanStack Query');
  });

  return PreviewKey.parse(response.data.data);
}
